export default class DtoDepartments {
    constructor(obj) {
        this.code = obj.code // String,
        this.name = obj.name // Option[String],
        this.nameRegion = obj.nameRegion // Option[String],
        this.nameOldRegion = obj.nameOldRegion // Option[String],
        this.countryISOCode = obj.countryISOCode // Option[String]
        this.labelWithCode = `${obj.name || ''} [${obj.code}]`
    }
}